import { render } from "./AdvanceConfirm.vue?vue&type=template&id=0123da7c&scoped=true"
import script from "./AdvanceConfirm.vue?vue&type=script&lang=js"
export * from "./AdvanceConfirm.vue?vue&type=script&lang=js"

import "./AdvanceConfirm.vue?vue&type=style&index=0&id=0123da7c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0123da7c"]])

export default __exports__